exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._38iVSOE7UZbVE5C_sjsLpb{font-weight:600;-ms-flex-negative:0;flex-shrink:0}html[dir=ltr] ._38iVSOE7UZbVE5C_sjsLpb{padding-right:3px}html[dir=rtl] ._38iVSOE7UZbVE5C_sjsLpb{padding-left:3px}.EhHTokBxnf7etdz-mes94{display:inline;list-style:none}html[dir] .EhHTokBxnf7etdz-mes94{padding:0;margin:0}.LCVeRO83tXYoTzFh6N4W9{display:inline}html[dir=ltr] .LCVeRO83tXYoTzFh6N4W9{margin-left:2px}html[dir=rtl] .LCVeRO83tXYoTzFh6N4W9{margin-right:2px}", ""]);
// Exports
exports.locals = {
	"label": "_38iVSOE7UZbVE5C_sjsLpb",
	"recipientsContainer": "EhHTokBxnf7etdz-mes94",
	"wellTrailingComponent": "LCVeRO83tXYoTzFh6N4W9"
};